import { ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { VoidCallback } from 'types/callbacks';

import styles from './RiveModal.module.css';
import { CloseIcon } from './svgIcons';

type Props = {
  display: boolean;
  onClose: VoidCallback;
  children: ReactNode;
};

export function RiveModal({ display, children, onClose }: Props) {
  const dialogRef = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      in={display}
      classNames={{
        enter: styles['DialogTransition-enter'],
        exit: styles['DialogTransition-exit'],
        enterActive: styles['DialogTransition-enter-active'],
        exitActive: styles['DialogTransition-exit-active'],
      }}
      timeout={200}
      unmountOnExit
    >
      <div
        className={styles.TransformContainer}
        onClick={(e) => {
          if (e.target === dialogRef.current) {
            onClose();
          }
        }}
      >
        <div ref={dialogRef} className={styles.DialogContainer}>
          {children}
        </div>
      </div>
    </CSSTransition>
  );
}

export function RiveModalCloseIcon({ onClose }: { onClose: VoidCallback }) {
  return (
    <button onClick={onClose} className={styles.CloseIcon}>
      <CloseIcon color="#cccccc" />
    </button>
  );
}
